import NextI18Next from 'next-i18next';

const localePath = (process.env.CWD || process.cwd()).endsWith('remotasks.com')
  ? 'public/static/locales'
  : 'remotasks.com/public/static/locales';

const nextI18Next = new NextI18Next({
  defaultLanguage: 'en',
  otherLanguages: ['es', 'ar', 'de', 'ko'],
  localePath,
  strictMode: false,
  react: {
    useSuspense: false,
    wait: true,
  },
  shallowRender: true,
  localeSubpaths: {
    es: 'es',
    ar: 'ar',
    en: 'en',
    de: 'de',
    ko: 'ko',
  },
  interpolation: { escapeValue: false },
  ignoreRoutes: ['/lidarlite/', '/.well-known/', '/videocaptioning/'],
});

export default nextI18Next;

const { withTranslation, appWithTranslation, useTranslation, i18n } = nextI18Next;

export { withTranslation, appWithTranslation, useTranslation, i18n };
